module.exports = __webpack_public_path__ + "static/media/gabriel-barbosa.67c46d46.jpeg";